import React from 'react'

import ButtonMenu from '../../ButtonMenu'
import NotificationItem from './NotificationItem'
import ViewMore from './ViewMore'

import useStyles from './styles'

const origin = {
  anchor: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  transform: {
    vertical: 'top',
    horizontal: 'right'
  }
}

const NotificationMenu = ({
  targetRef,
  options,
  onSelect,
  LIMIT,
  children,
  extraTopChildren
}) => {
  const classes = useStyles()

  return (
    <ButtonMenu
      id='notifications'
      options={options.slice(0, LIMIT)}
      onSelect={onSelect}
      renderFunc={id => (
        <NotificationItem id={id} options={options} LIMIT={LIMIT} />
      )}
      origin={origin}
      targetRef={targetRef}
      menuClass={classes.menu}
      extraTopChildren={extraTopChildren}
      extraMenuChildren={
        <ViewMore optionsLength={options.length} LIMIT={LIMIT} />
      }
    >
      {children}
    </ButtonMenu>
  )
}

export default NotificationMenu
